import { Alert, Button, Form, Input, Typography, message } from 'antd';
import { useState } from 'react';
import { post } from '../../../axios/axios';

const { Title } = Typography;

const WithdrawInfo = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const handleFinish = async (values) => {
        try {
            setLoading(true);
            const userInfo = localStorage.getItem('CommissionUserInfo');
            if (!userInfo) {
                message.error('请先登录');
                return;
            }

            const parsed = JSON.parse(userInfo);
            const token = parsed?.['Commission-Token'];
            if (!token) {
                message.error('未找到token，请重新登录');
                return;
            }

            const res = await post('/member/commission/withdraw-info/save', values, {
                headers: { 'Commission-Token': token },
            });

            if (res) {
                message.success('保存成功');
            }
        } catch (error) {
            console.error('保存提现信息失败:', error);
            // 错误信息已经在axios拦截器中通过message.error显示了
        } finally {
            setLoading(false);
        }
    };
    return (
        <div className="p-4">
            <Title level={4}>个人信息</Title>
            <Form form={form} layout="vertical" onFinish={handleFinish}>
                <Form.Item
                    name="bankCardNo"
                    label="收款银行卡号"
                    rules={[
                        { required: true, message: '请输入收款银行卡号' },
                        {
                            pattern: /^[1-9]\d{15}$/,
                            message: '请输入正确的银行卡号',
                        },
                    ]}
                >
                    <Input placeholder="请输入收款银行卡号" />
                </Form.Item>
                <Form.Item
                    name="bankName"
                    label="收款银行开户行（精确到支行）"
                    rules={[{ required: true, message: '请输入收款银行开户行（精确到支行）' }]}
                >
                    <Input placeholder="请输入收款银行开户行（精确到支行）" />
                </Form.Item>
                <Form.Item
                    name="cardHolderName"
                    label="银行卡预留姓名"
                    rules={[{ required: true, message: '请输入银行卡预留姓名' }]}
                >
                    <Input placeholder="请输入银行卡预留姓名" />
                </Form.Item>
                <Form.Item
                    name="cardHolderPhone"
                    label="银行卡预留手机号"
                    rules={[
                        { required: true, message: '请输入银行卡预留手机号' },
                        {
                            pattern: /^1[3-9]\d{9}$/,
                            message: '请输入正确的银行卡预留手机号',
                        },
                    ]}
                >
                    <Input placeholder="请输入银行卡预留手机号" />
                </Form.Item>
                <Form.Item
                    name="alipayAccount"
                    label="支付宝账号"
                    rules={[{ required: true, message: '请输入支付宝账号' }]}
                >
                    <Input
                        placeholder="请输入支付宝账号"
                        rules={[
                            { required: true, message: '请输入支付宝账号' },
                            {
                                pattern: /^[1-9]\d{15}$/,
                                message: '请输入正确的支付宝账号',
                            },
                        ]}
                    />
                </Form.Item>
                <Form.Item
                    name="alipayName"
                    label="支付宝姓名"
                    rules={[{ required: true, message: '请输入支付宝姓名' }]}
                >
                    <Input
                        placeholder="请输入支付宝姓名"
                        rules={[{ required: true, message: '请输入支付宝姓名' }]}
                    />
                </Form.Item>
                <div className="mb-4 text-primary">* 请确保所填信息正确无误，以确保收款成功</div>
                <Form.Item>
                    <Button type="primary" htmlType="submit" loading={loading}>
                        提交
                    </Button>
                </Form.Item>
            </Form>
        </div>
    );
};

export default WithdrawInfo;
